import { CartStorageDto, CartTotalsDto, CartItemDto, CartUserDto } from '../../dto'

export const DEFAULT_CART_USER: CartUserDto = {
	IdUsuario: 0,
	IdContacto: 0,
	IdCliente: null,

	CodCliente: '',
	TipoDocCliente: '',
	NumDocCliente: '',
	RazonSocial: '',
	Direccion: '',

	TipoDocumento: '',
	NroDocumento: '',

	Nombre: '',
	ApePaterno: '',
	ApeMaterno: '',

	NumCelular: '',
	Correo: ''
}

export const DEFAULT_CART_ITEM: CartItemDto = {
	IdArticulo: 0,
	CodCipsa: '',
	Nombre: '',
	IdMoneda: '',
	Precio: 0,
	Cantidad: 0,
	IdUnidadMedida: '',
	UnidadMedida: '',
	Factor: 0,
	PesoKg: 0,
	AnchoCm: 0,
	LargoCm: 0,
	AltoCm: 0,
	IdMonedaBase: '',
	PrecioBase: 0,
	IdAlmacen: '',
	ImgRuta: null
};

export const DEFAULT_CART_TOTALS: CartTotalsDto = {
	IdMonedaBase: '01SOL',
	SubTotal: 0,
	Envio: 0,
	Igv: 0,
	Total: 0
};

export const DEFAULT_CART_STORAGE: CartStorageDto = {
	created: new Date(),
	items: [],
	checkout: null,
	user: null,
	totals: { ...DEFAULT_CART_TOTALS },
	tc: null,
	orderCulqi: null,
	confirmation: null,
	payment: null
};

